import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'offline-voip-peer-summary',
  templateUrl: './offline-voip-peer-summary.component.html',
  styleUrls: ['./offline-voip-peer-summary.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class OfflineVoipPeerSummaryComponent implements OnInit {

  @Input()
  set selection(selection: any) {
    this.dataInitialization(selection);
  }

  constructor() {}

  voipPeer: any;

  ngOnInit(): void {
  }

  initializeData(): void {
    this.voipPeer.topologyGroups = _.isEmpty(this.voipPeer.topologyGroups) ? '' :
        this.voipPeer.topologyGroups.map(group => group.name).join(', ');
  }

  private dataInitialization(selection: any): void {
    if (_.isNil(selection)) { return; }

    const shapes = selection.nodes;
    const connections = selection.edges;
    if (shapes.length === 1 && connections.length === 0 && shapes[0].shapeType === 'voipPeer') {
      this.voipPeer = _.cloneDeep(shapes[0].dataItem);
      this.initializeData();
    }
  }
}
